import { useEffect, useState } from 'react';
import { useStyles } from './style';
import { useParams, useNavigate } from 'react-router-dom';
import Services from '../services';
import _ from 'lodash';
import {
  PageContainer,
  ButtonLoading,
  SimpleDialog,
  ExportButton,
  CommonTooltip,
} from 'components';
import RejectDescrptionMessageDialog from './components/RejectDescrptionMessageDialog';
import Details from './components/Details';
import ExportMessageDg from './components/ExportMessageDg';
import CollectionMessageDg from './components/CollectionMessageDg';
import { saveAs } from 'file-saver';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import { useCurrencyUnit } from 'hooks';
import clsx from 'clsx';
import { Grid, Button } from '@mui/material';
import { CartableRequestStatusCode } from 'utility';
export default function RequestPayDetails() {
  const [requester, setRequester] = useState(null);
  const currencyText = useCurrencyUnit(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const classes = useStyles();
  const param = useParams();
  const [isOpenDialogReciveFile, setIsOpenDialogReciveFile] = useState(false);
  const [isExportButtonLoading, setIsExportButtonLoading] = useState(false);
  const [isOpenExportDG, setIsOpenExportDG] = useState(false);
  const [isOpenCollectionDG, setIsOpenCollectionDG] = useState(false);
  const [isLoadinCollection, setIsLoadinCollection] = useState(false);
  const [isLoadinRequest, setIsLoadinRequest] = useState(false);
  const [isLoadinShow, setIsLoadinShow] = useState(false);
  const [message, setMessage] = useState('');
  const [finalList, setFinalList] = useState([]);
  const actionsList =
    getDynamicObjectAction([
      'multipleAccountDelegationGuildBtn',
      'withdrawMultipleShowGuildBtn',
      'multipleAccountDelegationBtn',
      'withdrawMultipleGroupGuildBtn',
      'detailsRequestCartbleBtn'

    ])
  const [isLoadingActionBtn, setIsLoadingActionBtn] = useState({
    showFile: false,
    requestFile: false,
    reciveFile: false,
  }); // 0 moshahedFileDarkhast ==> 1 requestReport ==>  2 reciveReport
  const [isOpenRejectDescrptionMessageDialog, setIsOpenRejectDescrptionMessageDialog] =
    useState(false);
  const styleObject = {
    blue: classes['customStyleBlue'],
    green: classes['customStyleGreen'],
    red: classes['customStyleRed'],
    white: classes['customStyleWhite'],
    gray: classes['customStyleWhite'],
  };

  const StatusStyleColor = {
    CARTABLE_REQUEST_WAITING: styleObject.blue,
    CARTABLE_REQUEST_CONFIRMED: styleObject.green,
    CARTABLE_REQUEST_FINALIZED: styleObject.green,
    CARTABLE_REQUEST_CANCELED: styleObject.red,
    CARTABLE_REQUEST_REJECTED: styleObject.red,
    CARTABLE_REQUEST_FAILED: styleObject.red,
    CARTABLE_REQUEST_EXPIRED: styleObject.red,
    CARTABLE_REQUEST_WAIT_FOR_APPROVE: styleObject.blue,
    CARTABLE_REQUEST_FILE_PROCESS_START: styleObject.green,
  };

  useEffect(() => {
    setTimeout(() => {
      !isOpenExportDG && setMessage('');
    }, 500);
  }, [isOpenExportDG]);
  const getRequest = async () => {
    let params = {
      offset: 0,
      size: 1,
      requestId: param?.id,
      roles: ['OWNER', 'REQUESTER', 'PENDING', 'CONFIRMER', 'APPROVER', 'REJECTOR'],
      operationType: 'or',
    };
    try {
      const res = await Services.getCartableRequestListRestfull(params);
      const obj = res.result[0]?.multiConfirmationUsageSrv;
      if (obj?.multiConfirmationSrv?.typeCode == 'MULTI_CONFIRMATION_TYPE_INVOICE') {
        // اگر از نوع فاکتور باشد باید سرویس جزییات فاکتور صدا بزنیم تا جزییات رو دریافت کنیم
        const factorDetails = await Services.getInvoiceDetails(
          obj?.requiredInfoToConfirm?.invoiceId,
        );
        obj['factorDetails'] = factorDetails?.result?.[0]; // برای اینکه استیت و آبجکت اضافی ایجاد نکنیم ، توی همون دیتای اصلی مون اطلاعات فاکتورو اضافه میکنیم
      }
      setData(obj);
      setLoading(false);
      let confirmersList = res.result[0]?.confirmerList || [];
      const allList = res.result[0].multiConfirmationUsageSrv?.confirmers || [];
      let finalList = [];
      let checkStatusColor = [];
      for (let item of confirmersList) {
        if (allList.find((a) => a.id == item?.userSrv?.id)) {
          checkStatusColor.push(item);
        }
      }
      checkStatusColor = checkStatusColor.sort(function (a, b) {
        return parseFloat(a.order) - parseFloat(b.order);
      });
      var goupByList = _.groupBy(confirmersList, 'order');
      //===============================================
      if (obj?.requester) {
        setRequester(obj);
        finalList.push({
          content: breakString(obj?.requester.name),
          tooltip: obj?.requester.name,
          class: styleObject.green,
        });
      }
      // ===========================================
      const d = ConvertDataSet(goupByList);
      finalList = [...finalList, ...d];
      ///======================================
      if (obj?.statusCode) {
        finalList.push({
          content: breakString(CartableRequestStatusCode[obj?.statusCode]),
          tooltip: CartableRequestStatusCode[obj?.statusCode],
          class: StatusStyleColor[obj?.statusCode],
        });
      }
      setFinalList(finalList);
    } catch (error) {
      setLoading(false);
    }
  };

  const ConvertDataSet = (data) => {
    let arr = [];
    for (let key in data) {
      var obj = data[key];
      for (let item of obj) {
        arr.push({
          content: breakString(item?.userSrv?.name),
          tooltip: getTitle(item, obj),
          class: styleObject[String(item?.color).toLowerCase()],
        });
      }
    }
    return arr;
  };

  const getTitle = (item, list) => {
    if (item.condition == 'AND') {
      return `تایید کاربر ${item?.userSrv?.name} اجباری است`;
    } else {
      if (item?.count == 1) {
        return `کاربر ${item?.userSrv?.name} میتواند تایید کننده باشد`;
      } else {
        let users = Array.from(list).filter((a) => a?.count == item?.count && a.condition == 'OR');
        let names = users.length > 0 ? users.map((a) => a?.userSrv?.name).join(' و ') : '';
        let titles = `${item?.count} نفر از ${users.length} کاربر ${names} باید تایید کنند`;
        return titles;
      }
    }
  };

  const breakString = (str) => {
    return String(str).length > 17 ? str.toString().slice(0, 17) + '...' : str;
  };
  /**
   * کلیک بر روی دکمه دریافت گزارش پرداخت
   */
  const onclickBtnReciveFileReport = async () => {
    try {
      setIsExportButtonLoading(true);

      setIsLoadingActionBtn({ ...isLoadingActionBtn, reciveFile: true });
      if (data?.resultFile || data?.resultFileHashCode) {
        let obj = {
          fileHash: data?.resultFileHashCode || data?.resultFile.hashCode,
        }
        data?.resultFile && (obj['fileId'] = data?.resultFile?.id);
        const recivefile = await Services.getFile(obj);
        exportCSV(recivefile, 'reportFile');
      } else {
        setIsOpenDialogReciveFile(true);
      }
      setIsLoadingActionBtn({ ...isLoadingActionBtn, reciveFile: false });
      setIsExportButtonLoading(false);
    } catch (error) {
      setIsLoadingActionBtn({ ...isLoadingActionBtn, reciveFile: false });
      setIsExportButtonLoading(false);
    }
  };
  /**
   * کلیک بر روی دکمه مشاهده فایل درخواست
   */
  const onShowFile = async () => {
    setIsLoadingActionBtn({ ...isLoadingActionBtn, showFile: true });

    let p = {};
    if (data.requestFile && data.requestFile?.hashCode) {
      p = { fileHash: data.requestFile?.hashCode, fileId: data?.requestFile?.id };
    } else {
      p = { fileHash: data.requestFileHashCode }
    }


    let type = '';
    if (
      data?.multiConfirmationSrv?.typeCode === 'MULTI_CONFIRMATION_TYPE_DELEGATION_RULE' &&
      (data?.requestFile || data?.requestFileHashCode)
    ) {
      type = 'DELEGATION_CARTABLE';
    } else if (
      data?.multiConfirmationSrv?.typeCode === 'MULTI_CONFIRMATION_TYPE_TRANSFER' &&
      (data?.requestFile || data?.requestFileHashCode)
    ) {
      type = 'CONTACT_CARTABLE';
    }
    if (type) {
      await Services.exportMultipleTransferXls(param?.id, type)
        .then((res) => {
          exportXlsx(res, 'requestCartableFile');
          setIsLoadingActionBtn({ ...isLoadingActionBtn, showFile: false });
          return;
        })
        .catch((error) => {
          setIsLoadingActionBtn({ ...isLoadingActionBtn, showFile: false });
        });
    } else {
      Services.getFile(p)
        .then((res) => {
          setIsLoadingActionBtn({ ...isLoadingActionBtn, showFile: false });
        })
        .catch((error) => {
          setIsLoadingActionBtn({ ...isLoadingActionBtn, showFile: false });
        });
    }
  };

  const exportCSV = (data, title = 'exportFile') => {
    const ctype = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
    const reader = new FileReader();
    reader.readAsText(
      new Blob([data], {
        type: ctype,
      }),
    );
    reader.onloadend = function () {
      const csvString = reader.result;
      const universalBOM = '\uFEFF';
      const a = window.document.createElement('a');
      a.setAttribute(
        'href',
        `data:text/csv; charset=utf-8,${encodeURIComponent(universalBOM + csvString)}`,
      );
      a.setAttribute('download', title);
      window.document.body.appendChild(a);
      a.click();
    };
  };
  const exportXlsx = (data, title = 'exportFile') => {
    const ctype = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
    saveAs(new Blob([data], { type: ctype }), title);
  };
  const reportGroupRequest = async () => {
    try {
      setIsExportButtonLoading(true);
      setIsLoadinRequest(true);
      const req = await Services.reportGroupRequest(param?.id);
      setIsExportButtonLoading(false);
      setIsLoadinRequest(false);
      setMessage('MESSAGE_REQUEST_BANKI');
      setIsOpenExportDG(true);
    } catch (error) {
      setIsExportButtonLoading(false);
      setIsLoadinRequest(false);
    }
  };
  const reportGroupRequestReciveFile = async () => {
    try {
      setIsExportButtonLoading(true);
      setIsLoadinShow(true);
      const req = await Services.reportGroupRequestReciveFile(param?.id);
      if (req) {
        if (req?.statusCode == 'MULTICONFIRMATION_REPORT_DONE') {
          const recivefile = await Services.getFile({
            fileHash: req?.resultFileHashCode || req?.resultFile.hashCode

          });

          //exportCSV(recivefile, 'reportFileBank')
          exportXlsx(recivefile, 'reportFileBank');
        } else {
          setMessage('MESSAGE_SHOW_STATUS_REQUEST_BANKI');
          setIsOpenExportDG(true);
        }
      }
      setIsExportButtonLoading(false);
      setIsLoadinShow(false);
    } catch (error) {
      setIsExportButtonLoading(false);
      setIsLoadinShow(false);
    }
  };
  const onExport = (type, index) => {
    if (index == 0) {
      // آنی
      onclickBtnReciveFileReport();
    } else if (index == 1) {
      // درخواست وضعیت
      reportGroupRequest();
    } else {
      // مشاهده وضعیت
      reportGroupRequestReciveFile();
    }
  };
  /**
   * رویداد مربوط به دکمه کارت جمع
   */
  const getCollectionCard = async () => {
    try {
      setIsLoadinCollection(true);
      const req = await Services.requestCollectionCard(param?.id);
      if (req) {
        let obj = {};
        if (req.resultFile) {
          obj = {
            fileHash: req?.resultFile?.hashCode,
            fileId: req?.resultFile?.id
          }
        } else {
          obj = { fileHash: req?.resultFileHashCode }
        }
        const recivefile = await Services.getFile(obj);
        exportXlsx(recivefile, 'reportCollectionCart');
      } else {
        setIsOpenCollectionDG(true);
      }
      setIsLoadinCollection(false);
    } catch (error) {
      setIsLoadinCollection(false);
    }
  };
  useEffect(() => {
    getRequest();
  }, []);
  
  return (
    <>
      <PageContainer
        title="جزئیات درخواست"
        breadcrumbs={constBreadCrumbsTitle.CARTABLE_REQUEST_PAY_DETAIL}
        className={classes.root}
        onBackClick={() => navigate(-1)}
        loading={loading}
      >
        {(actionsList['withdrawMultipleShowGuildBtn'] || actionsList['multipleAccountDelegationBtn'] || actionsList['multipleAccountDelegationGuildBtn'] || actionsList['detailsRequestCartbleBtn']) && (
          <Details data={data} currencyText={currencyText} />
        )}
      </PageContainer>
      {(actionsList['withdrawMultipleShowGuildBtn'] || actionsList['multipleAccountDelegationBtn'] || actionsList['multipleAccountDelegationGuildBtn'] || actionsList['detailsRequestCartbleBtn']) && (
        !loading && requester && (
          <>
            <PageContainer>
              <Grid className={classes.w100}>
                <Grid container className={classes.topPartChart}>
                  {/* این قسمت برای حالت موبایل و لارج توی سایز های مختلف شرظ گذاشتم که اگه گروهی نباشه و نهایی شده نباشه که اون دکمه های سمت چپ رو نشون بده  */}
                  <Grid
                    xs={12}
                    md={
                      !data?.requestFileHashCode && !data.requestFile && data?.statusCode != 'CARTABLE_REQUEST_FINALIZED' ? 12 : 9
                    }
                    lg={
                      !data?.requestFileHashCode && !data.requestFile && data?.statusCode != 'CARTABLE_REQUEST_FINALIZED' ? 12 : 9
                    }
                  //style={{marginTop:'-8px', marginLeft:'24px'}}
                  >
                    {data.statusCode == 'CARTABLE_REQUEST_REJECTED' && (
                      <Grid item xs={12} md={7} lg={7} style={{ textAlign: 'justify' }}>
                        <span className={classes.detailValue}>علت رد درخواست: </span>
                        <span className={classes.detailTitle}>{data?.rejectReason || ''}</span>
                      </Grid>
                    )}
                  </Grid>
                  <Grid container xs={12} md={3} lg={3} className={classes.btnActions}>
                    {(data.requestFile || data?.requestFileHashCode) ? (
                      <>
                        <ButtonLoading
                          variant="contained"
                          color="primary"
                          loading={isLoadingActionBtn.showFile}
                          name="مشاهده فایل درخواست"
                          type="button"
                          onClick={onShowFile}
                          className={classes.marginSpace}
                          style={{ width: '185px' }}
                        />
                        {data?.statusCode == 'CARTABLE_REQUEST_FINALIZED' ? (
                          <>
                            <ExportButton
                              label={'وضعیت پرداخت'}
                              isExport={false}
                              loading={isExportButtonLoading}
                              types={['وضعیت پرداخت آنی', 'درخواست وضعیت', 'مشاهده وضعیت']}
                              onExport={onExport}
                              style={{ width: '185px' }}

                            />

                            <ButtonLoading
                              variant="contained"
                              color="primary"
                              loading={isLoadinCollection}
                              name="کارت جمع"
                              style={{ width: '185px' }}
                              type="button"
                              onClick={getCollectionCard}
                              className={classes.marginSpace}
                            />
                          </>
                        ) : (
                          <div
                            className={classes.dvDisable}
                            title=" تا زمان تعیین وضعیت نهایی درخواست امکان دریافت و مشاهده گزارش پرداخت وجود ندارد."
                          >
                            دریافت گزارش پرداخت
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        {data?.statusCode == 'CARTABLE_REQUEST_FINALIZED' && (
                          <>
                            <ButtonLoading
                              variant="contained"
                              color="primary"
                              loading={isLoadinRequest}
                              name="درخواست وضعیت"
                              type="button"
                              onClick={reportGroupRequest}
                              className={classes.marginSpace}
                              style={{ width: '185px' }}

                            />
                            <ButtonLoading
                              variant="contained"
                              color="primary"
                              loading={isLoadinShow}
                              name="مشاهده وضعیت"
                              type="button"
                              onClick={reportGroupRequestReciveFile}
                              className={classes.marginSpace}
                              style={{ width: '185px' }}

                            />
                          </>
                        )}
                      </>
                    )}
                  </Grid>
                </Grid>

                <Grid
                  className={clsx(
                    classes.boxChart,
                    data?.requestFileHashCode || data.requestFile ||
                      data.statusCode == 'CARTABLE_REQUEST_REJECTED' ||
                      data.statusCode == 'CARTABLE_REQUEST_FINALIZED'
                      ? classes.mt64
                      : '',
                  )}
                  container
                >
                  <Grid container style={{ flex: '4' }}>
                    <Grid className={classes.boxItemChart}>
                      <Grid className={classes.titleRowChart}>درخواست دهنده</Grid>
                      <Grid className={classes.contentItemChart}>
                        <CommonTooltip placement="right" title={finalList[0]?.tooltip}>
                          <span className={clsx(classes.chartItem, finalList[0]?.class)}>
                            {finalList[0]?.content}
                          </span>
                        </CommonTooltip>
                      </Grid>
                    </Grid>
                    <Grid className={classes.boxItemChart}>
                      <Grid className={classes.titleRowChart}>وضعیت تایید</Grid>
                      <Grid className={classes.contentItemChart}>
                        {finalList.map((item, index) => {
                          return (
                            index !== 0 &&
                            finalList.length - 1 !== index && (
                              <CommonTooltip placement="top" title={item?.tooltip}>
                                <span className={clsx(classes.chartItem, item?.class)}>
                                  {item?.content}
                                </span>
                              </CommonTooltip>
                            )
                          );
                        })}
                      </Grid>
                    </Grid>
                    <Grid className={classes.boxItemChart}>
                      <Grid className={classes.titleRowChart}>وضعیت درخواست</Grid>
                      <Grid className={classes.contentItemChart}>
                        <CommonTooltip
                          placement="right"
                          title={finalList[finalList.length - 1]?.tooltip}
                        >
                          <span
                            className={clsx(
                              classes.chartItem,
                              finalList[finalList.length - 1]?.class,
                            )}
                          >
                            {finalList[finalList.length - 1]?.content}
                          </span>
                        </CommonTooltip>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container className={classes.boxGuidChart}>
                    <Grid className={classes.w100}>راهنما</Grid>
                    <Grid className={classes.guidItemColor}>
                      <span>رد شده، لغو شده، ناموفق، منقضی شده</span>
                      <span
                        className={classes.guidCircleItem}
                        style={{ backgroundColor: '#a61b0e' }}
                      ></span>
                    </Grid>

                    <Grid className={classes.guidItemColor}>
                      <span>پرداخت موفق، تایید شده</span>
                      <span
                        className={classes.guidCircleItem}
                        style={{ backgroundColor: '#547c00' }}
                      ></span>
                    </Grid>
                    <Grid className={classes.guidItemColor}>
                      <span>در انتظار تایید</span>
                      <span
                        className={classes.guidCircleItem}
                        style={{ backgroundColor: '#1ba4dc' }}
                      ></span>
                    </Grid>
                  </Grid>
                  <h5 className={classes.titleChart}>نمودار وضعیت</h5>
                </Grid>
              </Grid>
            </PageContainer>
            <SimpleDialog
              fullWidth
              maxWidth="sm"
              open={isOpenDialogReciveFile}
              title="دریافت گزارش پرداخت"
            >
              <Grid container style={{ textAlign: 'justify' }}>
                گزارش درخواستی آماده نمی باشد لطفا دقایقی دیگر مجدد تلاش نمایید.
              </Grid>
              <Grid style={{ display: 'flex', marginTop: '16px', flexDirection: 'row-reverse' }}>
                <Button
                  variant="contained"
                  onClick={() => setIsOpenDialogReciveFile(false)}
                  style={{ marginRight: '8px' }}
                >
                  بستن
                </Button>
              </Grid>
            </SimpleDialog>
            <RejectDescrptionMessageDialog
              setIsOpenDialog={setIsOpenRejectDescrptionMessageDialog}
              isOpenDialog={isOpenRejectDescrptionMessageDialog}
              data={data}
            />
            <ExportMessageDg
              isOpenExportDG={isOpenExportDG}
              setIsOpenExportDG={setIsOpenExportDG}
              message={message}
            />
            <CollectionMessageDg
              isOpenCollectionDG={isOpenCollectionDG}
              setIsOpenCollectionDG={setIsOpenCollectionDG}
            />
          </>
        )
      )}
    </>
  );
}
